




import Vue from "vue";
import NotificationDataUpload from "@/components/notification-data/notification-data-upload.component.vue";
export default Vue.extend({
  components: {
    "notification-data-upload": NotificationDataUpload,
  },
});
